const returnPhoneNumberFormat = (phone)=>{
    if (typeof phone !== 'string') return '-';

    // Удаляем всё, кроме цифр
    const digits = phone.replace(/\D/g, '');

    // Проверяем длину номера — минимум 11 цифр (например: 71234567890)
    if (digits.length < 11) return '-';

    // Убираем лишнюю восьмёрку в начале, если есть
    let normalized = digits;
    if (digits.length === 11 && digits[0] === '8') {
        normalized = '7' + digits.slice(1);
    }

    // Если номер начинается с 7 — форматируем как +7 (...)
    if (normalized[0] === '7') {
        return (
            '+7 (' +
            normalized[1] + normalized[2] + normalized[3] + ') ' +
            normalized[4] + normalized[5] + normalized[6] + '-' +
            normalized[7] + normalized[8] + '-' +
            normalized[9] + normalized[10]
        );
    }

    // Если не 7 — просто вернём номер с плюсом
    return '+' + normalized;
};

export default returnPhoneNumberFormat;
